App.namespace.wrap('es6.shared.form_validation', function ({ $form }) {
  const regexValidator = App.es6.shared.regex_validator();
  let isValid = true;

  const ERROR_CLASS = 'has-error';
  const FIELD_PARENT = '.form-group';
  const FIELD_ERROR = '.field-error';

  const VALIDATOR_CLASS = {
    fieldRequired: '.js-required',
    notEmail: '.js-not-email',
    validEmail: '.js-valid-email',
    validURL: '.js-valid-url',
    validPhone: '.js-valid-phone',
    password: '.js-valid-pass',
    length: '.js-valid-length',
    maxLength: '.js-valid-max-length',
    passwordConfirmation: '.js-valid-pass-conf',
    requiredSelectedCheckbox: '.js-require-selected',
    requiredChosenOption: '.js-require-chosen-option',
    positiveInteger: '.js-require-positive-integer',
  }

  let $firstErrorField;

  const validate = () => {
    resetForm();

    const validatorsToCheck = [ // The order of the validators will determine the order of specific error messages
      validateNotEmail,
      validateEmail,
      validateURL,
      validatePhone,
      validateLength,
      validateMaxLength,
      validatePasswordMatch,
      validateSelectedCheckbox,
      validateChosenOption,
      validatePositiveInteger,
      validateRequired,
    ];

    validatorsToCheck.forEach((validator) => {
      if (typeof validator !== 'function' || validator() === false) {
        isValid = false;
      }
    })

    if ($firstErrorField) {
      const element = $firstErrorField.get()[0];
      if (element.scrollIntoViewIfNeeded) {
        element.scrollIntoViewIfNeeded({ behavior: 'smooth' });
      } else {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    return isValid;
  };

  const genericValidator = ({ fieldClass, condition }) => {
    const $fields = $form.find(fieldClass);
    let isValid = true;
    if ($fields.length === 0) {
      return true;
    }
    $fields.each((index, el) => {
      const $el = $(el);
      if (!condition($el)) {
        setFieldError($el, true, fieldClass);
        isValid = false;
      }
    });
    return isValid;
  };

  const validatePositiveInteger = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.positiveInteger,
      condition: $el => {
        const num = parseFloat($el);
        return num > 0 && num % 1 === 0;
      },
    });
  };

  const validateRequired = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.fieldRequired,
      condition: $el => ($el.val() !== '' && $el.val() !== null),
    });
  };

  const validateEmail = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.validEmail,
      condition: $el => (regexValidator.isValidEmail($el.val())),
    });
  }

  const validateNotEmail = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.notEmail,
      condition: $el => (regexValidator.isNotEmail($el.val())),
    });
  }

  const validateURL = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.validURL,
      condition: $el => (regexValidator.isValidUrl($el.val())),
    });
  };

  const validatePhone = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.validPhone,
      condition: $el => (regexValidator.isValidPhone($el.val().trim())),
    });
  };

  const validateSelectedCheckbox = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.requiredSelectedCheckbox,
      condition: $el => ($el.prop('checked')),
    });
  };

  const validateChosenOption = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.requiredChosenOption,
      condition: $el => {
        const inputName = $el.attr('name')
        return $form.find($(`[name="${inputName}"]:checked`)).length > 0
      },
    });
  }

  const validateLength = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.length,
      condition: $el => {
        const length = $el.val().length;
        const minLength = $el.data('limit');
        return length >= minLength;
      },
    });
  };

  const validateMaxLength = () => {
    return genericValidator({
      fieldClass: VALIDATOR_CLASS.maxLength,
      condition: $el => {
        const length = $el.val().length;
        const maxLength = $el.data('max-limit');
        return length <= maxLength;
      },
    });
  };

  const validatePasswordMatch = () => {
    const $pass = $form.find(VALIDATOR_CLASS.password);
    const $passConf = $form.find(VALIDATOR_CLASS.passwordConfirmation);
    if ($pass.length === 0 || $passConf.length === 0) {
      return true;
    }
    if ($pass.val() !== $passConf.val()) {
      setFieldError($passConf, true, VALIDATOR_CLASS.passwordConfirmation);
      return false;
    }
    return true;
  };

  const setFieldErrorMessage = (errorSelector, $fieldError) => {
    let errorMessage = $fieldError.data('error');
    if (errorSelector) {
      const errorClass = errorSelector.substring(1);
      const specificErrorMessage = $fieldError.data(`error-${errorClass}`);
      if (specificErrorMessage) {
        errorMessage = specificErrorMessage;
      }
    }

    if (errorMessage) {
      $fieldError.text(errorMessage);
    }
  };

  const setFieldError = ($el, enabled, errorSelector) => {
    const $parent = $el.closest(FIELD_PARENT);

    const $fieldError = $parent.find(FIELD_ERROR);
    setFieldErrorMessage(errorSelector, $fieldError);

    if (!$firstErrorField) {
      $firstErrorField = $parent;
    }
    return (enabled) ? $parent.addClass(ERROR_CLASS) : $parent.removeClass(ERROR_CLASS);
  };

  const resetForm = () => {
    $firstErrorField = null;
    isValid = true;
    $form.find(`.${ERROR_CLASS}`).each((index, el) => {
      $(el).removeClass(ERROR_CLASS);
    });
    $form.removeClass(ERROR_CLASS)
  };

  const registerEvents = () => {
    const $fields = $form.find('input, select, textarea');
    $fields.each((index, el) => {
      $(el).unbind('change keydown').bind('change keydown', (e) => {
        setFieldError($(e.currentTarget), false);
      });
    });
  };

  const init = () => {
    registerEvents();
  };

  return {
    init,
    validate,
  }
});
